// extracted by mini-css-extract-plugin
export default {"project":"Project_project__S5SO7","projectImg":"Project_projectImg__rJmrm","projectTitle":"Project_projectTitle__djFmX","projectDescription":"Project_projectDescription__4da5o"};